export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/booking-success',
      name: 'distributor-train-front-booking-success',
      component: () => import('./index.vue'),
    },
  ]
};
